/** GxChipGroup: one choice from a short list drawn as a row of chips (a radio group), so every option is on the page with its stable name and nothing hides in a dropdown. */
import { RovingGroup } from "./roving";
export function GxChipGroup<V extends string | number>({ label, value, options, onChange, testId }: {
  readonly label: string; readonly value: V | null; readonly options: readonly (readonly [V, string])[]; readonly onChange: (v: V) => void; readonly testId?: string;
}) {
  return (
    <RovingGroup className="gx-chips" role="radiogroup" aria-label={label} data-testid={testId}>
      {options.map(([v, l]) => <button key={v} type="button" role="radio" aria-checked={v === value} className="gx-chip" onClick={() => onChange(v)}>{l}</button>)}
    </RovingGroup>
  );
}
